import { citiesInCountry, citiesInState } from "../services/thirdParty/citiesNowApi"

export const getCitiesBasedOnState = async (country, state) => {
    const params = {
        country: country,
        state: state
    }
    const citiesList = await citiesInState(params);
    return citiesList;
}

export const getCitiesBasedOnCountry = async (country) => {
    const params = {
        country: country
    }
    const citiesList = await citiesInCountry(params);
    return citiesList;
}